import { useEffect, useRef, useState } from 'react';
import { PrimaryButton } from './Button';
import QrScanner from 'qr-scanner';
function Scanner({ onScan, }) {

  const containerRef = useRef(null);
  const videoRef = useRef(null);
  let scanner = undefined;

  const [result, setResult] = useState('');
  const [message, setMessage] = useState('');
  const [manualInput, setManualInput] = useState('');

  const setQrResult = (qrResult) => {
    if (!qrResult || !qrResult.data) {
      console.log('No QR code found. Please try again.');
      return;
    }
    console.log(qrResult.data);
    setResult(qrResult.data);
    setMessage('Code scanned successfully');

    onScan(qrResult.data); // Call the onScan prop with the result
    scanner.stop(); // Stop scanning after a successful scan
  }

  const init = async () => {
    try {
      console.log('Initializing scanner');
      //throw new Error('Scanner initialization not supported in this environment'); // Uncomment this line to simulate an error
      setResult('');
      const video = videoRef.current;
      scanner = new QrScanner(video, qrResult => setQrResult(qrResult), {
        onDecodeError: error => {
        },
        highlightScanRegion: true,
        highlightCodeOutline: true,
      });

      await scanner.start()

    } catch (error) {
      console.error('Error initializing scanner:', error);
      setMessage('Error initializing scanner: ' + error.message);
    }
  };


  useEffect(() => {
    init();
    return () => {
      console.log('Cleaning up scanner');
      scanner?.stop(); // Stop the scanner when the component unmounts
    };
  }, []);

  const containerStyle = `${(result || message) ? 'hidden' : ''} example-style-2`;

  return (
    <div>
      <div id="video-container" class={containerStyle} ref={containerRef}>
        <video id="qr-video" ref={videoRef}></video>
      </div>
      {message}
    </div>
  );
}

export default Scanner;